import { createContext, ReactNode } from "react";

import { ActionCreatorWithPayload } from "@reduxjs/toolkit";

import { SearchColumn, SearchObject, SortColumn, TableColumn } from "@sso/types";

interface SearchAction {
  object: SearchObject;
  onChange: ActionCreatorWithPayload<SearchColumn, string>;
  onClear: ActionCreatorWithPayload<string, string>;
}
export interface TableProviderState {
  columns: TableColumn[];
  pageSize: { value: number; action: ActionCreatorWithPayload<number, string> };
  pagination: {
    totalPages: number;
    pageIndex: number;
    action: ActionCreatorWithPayload<number, string>;
  };
  sort?: SortColumn;
  search?: SearchAction;
}

interface TableProviderProps {
  children: ReactNode;
  tableInstance: TableProviderState;
}

export const TableContext = createContext<TableProviderState>({} as TableProviderState);

export const TableProvider = ({ children, tableInstance }: TableProviderProps) => {
  return <TableContext.Provider value={tableInstance}>{children}</TableContext.Provider>;
};
